import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { TwDocumentacionCamViewModel } from '../documentacioncam.types';
import { proxiedPropertiesOf } from '../../../../../core/_infrastructure/types/utils';
import { Table } from 'primeng/table';
import { OnChanges } from '@angular/core';

@Component({
    selector: 'app-documentacioncam-list',
    templateUrl: './documentacioncam-list.component.html',
    styleUrls: ['./documentacioncam-list.component.scss'],
})
export class DocumentacionCamListComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() documentos: TwDocumentacionCamViewModel[];
    @Input() adjuntarDocumentacion: boolean;
    @Output() delete: EventEmitter<TwDocumentacionCamViewModel> = new EventEmitter();
    @Output() undoDelete: EventEmitter<TwDocumentacionCamViewModel> = new EventEmitter();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.documentos?.currentValue) {
            this.documentos = changes.documentos.currentValue;
        }
    }

    private initCols(): void {
        const documentos = proxiedPropertiesOf<TwDocumentacionCamViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: documentos.IdTipoDocumentacionDescripcion?.toString(), header: 'Tipo de Documentación' },
            { field: documentos.Obligatoria?.toString(), header: 'Obligatoria' },
        ];
    }

    onDelete(documentationRow: TwDocumentacionCamViewModel) {
        this.delete.emit(documentationRow);
    }

    onUndoDelete(documentationRow: TwDocumentacionCamViewModel) {
        this.undoDelete.emit(documentationRow);
    }
}
